__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "bpop-salaryloans-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "17.3.12", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(236), __webpack_require__.e(482), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "17.3.12", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core", "17.3.12", () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(8559))))));
			register("@angular/router", "17.3.12", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(236), __webpack_require__.e(482), __webpack_require__.e(230), __webpack_require__.e(517), __webpack_require__.e(484)]).then(() => (() => (__webpack_require__(517))))));
			register("@avaldigitallabs/adl-commons-lib-frontend-event-bus", "1.2.2", () => (__webpack_require__.e(434).then(() => (() => (__webpack_require__(7434))))));
			register("@avaldigitallabs/bpop-lib-frontend-security", "2.0.2", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(236), __webpack_require__.e(230), __webpack_require__.e(147), __webpack_require__.e(76), __webpack_require__.e(899)]).then(() => (() => (__webpack_require__(5147))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};